import { useState } from "react";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

import { useTranslation } from 'react-i18next';
import { COLORES_APP } from "../utils/constantes";

import Logo from '../img/logo-ayto.png';

import { login } from '../api/LoginApi.js';

export default function Login({ onLogin }) {
  	const [email, setEmail] = useState("");
  	const [contrasena, setContrasena] = useState("");
  	const [error, setError] = useState("");

  	const { t } = useTranslation();

  	const handleSubmit = async (e) => {
    	e.preventDefault();
    	setError("");

    	try {
      		await login({ email, contrasena });
      		onLogin();

    	} catch (err) {

			if(err?.response?.status === 403) {
				setError(t('login.premisos_err'));

			} else if(err?.response?.status === 429) {
				setError(err?.response?.data);

			} else {
				setError(t('login.credenciales_err'));
			}
    	}
  	};

  	return (
		<div style={{
			minHeight: "100vh",
			background: `linear-gradient(135deg, ${COLORES_APP.AZUL} 0%, ${COLORES_APP.AMARILLO} 100%)`,
			display: "flex",
			alignItems: "center",
			justifyContent: "center"
		}}>

			<form onSubmit={handleSubmit} style={{
				background: "#fff",
				padding: 40,
				borderRadius: 16,
				boxShadow: "0 8px 32px rgba(66, 118, 152, 0.18)",
				minWidth: 340,
				maxWidth: 360,
				width: 360,
				animation: "fadeIn 1s",
				display: "flex",
				flexDirection: "column",
				alignItems: "center"
			}}>
				<img src={Logo} alt="Ajuntament de Sant Julià de Vilatorta" style={{ width: 210, marginBottom: 18, marginTop: -10 }} />

				<div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 24 }}>
					<h2 style={{ color: COLORES_APP.MARRON, margin: 0, fontWeight: 700, fontSize: 28 }}>{t('login.titulo')}</h2>
				</div>

				<div style={{ marginBottom: 20, position: "relative", width: "100%" }}>
					<AlternateEmailIcon style={{ position: "absolute", left: 10, top: 10, color: COLORES_APP.AZUL, fontSize: 22 }} />
					<input
						type="email"
						value={email}
						onChange={e => setEmail(e.target.value)}
						required
						placeholder={t('login.email')}
						style={{
						width: "100%",
						boxSizing: "border-box",
						padding: "10px 10px 10px 38px",
						borderRadius: 6,
						border: `1.5px solid ${COLORES_APP.AZUL}`,
						fontSize: 16,
						outline: "none"
						}}
					/>
				</div>

				<div style={{ marginBottom: 20, position: "relative", width: "100%" }}>
					<LockOutlinedIcon style={{ position: "absolute", left: 10, top: 10, color: COLORES_APP.AZUL, fontSize: 22 }} />
					<input
						type="password"
						value={contrasena}
						onChange={e => setContrasena(e.target.value)}
						required
						placeholder={t('login.password')}
						style={{
						width: "100%",
						boxSizing: "border-box",
						padding: "10px 10px 10px 38px",
						borderRadius: 6,
						border: `1.5px solid ${COLORES_APP.AZUL}`,
						fontSize: 16,
						outline: "none"
						}}
					/>
				</div>

				<div
					style={{
						color: "red",
						marginBottom: 12,
						textAlign: "center",
						minHeight: 24,
						visibility: error ? "visible" : "hidden",
					}}
				>
					{error || "placeholder"}
				</div>

				<button
					type="submit"
					style={{
						width: "100%",
						background: COLORES_APP.AMARILLO,
						color: COLORES_APP.MARRON,
						border: "none",
						padding: 14,
						borderRadius: 6,
						fontWeight: "bold",
						fontSize: 17,
						cursor: "pointer",
						boxShadow: `0 2px 8px ${COLORES_APP.AZUL}22`,
						transition: "background 0.2s, color 0.2s"
					}}
					onMouseOver={e => {
						e.target.style.background = COLORES_APP.AZUL;
						e.target.style.color = "#fff";
					}}
					onMouseOut={e => {
						e.target.style.background = COLORES_APP.AMARILLO;
						e.target.style.color = COLORES_APP.MARRON;
					}}
				>
					{t('login.entrar')}
				</button>
			</form>
			<style>{`
				@keyframes fadeIn {
				from { opacity: 0; transform: translateY(30px); }
				to { opacity: 1; transform: translateY(0); }
				}
			`}</style>
		</div>
	);
} 